import React, { useState } from 'react';

import { link } from '../../helpers/link';
import './DiscountProgramProductList.scss';
import sendEvent from '../../helpers/tracking';

import DiscountProgramProduct from '../DiscountProgramProduct/DiscountProgramProduct.jsx';

export default function DiscountProgramProductList(props) {
  const { title, list, infinitifeScrolling, nextLink, fetchMore } = props;

  const observer = {};
  const [loading, setLoading] = useState(false);
  const [observableNodes, setObservableNodes] = useState(new Set());

  return (
    <section className="discountProgramProductList">
      <h2>{title}</h2>

      <ul>
        {list.map((product, idx) => {
          const id =
            (product.campaign && product.campaign.xuid) ||
            product.xuid ||
            product.id;

          return id ? (
            <li key={idx}>
              {infinitifeScrolling ? (
                <div>
                  <DiscountProgramProduct
                    {...props}
                    view="miniature"
                    product={product}
                  />

                  {idx === list.length - 4 && (
                    <span ref={observe} data-id={idx} />
                  )}
                </div>
              ) : (
                <DiscountProgramProduct
                  {...props}
                  view="miniature"
                  product={product}
                />
              )}
            </li>
          ) : null;
        })}
      </ul>

      {loading && (
        <div style={{ margin: '30px auto 0 auto' }}>
          <img alt="loading" src="/loading.gif" />
        </div>
      )}

      {!infinitifeScrolling &&
        link(
          <p
            onClick={() =>
              props.eventTrackingCodes &&
              sendEvent(props.eventTrackingCodes[0], 'Range-pr')
            }
            className="discountProgramProductList_link"
          >
            Naar ons complete aanbod
          </p>,
          '/discount-program-categories',
          nextLink
        )}
    </section>
  );

  function observe(node) {
    if (!node) return;

    if (!observer.instanse)
      observer.instanse = new IntersectionObserver((entries) =>
        entries.forEach((entry) => entry.isIntersecting && fetchMoreContent(15))
      );

    const { id } = node.dataset;

    if (observableNodes.has(id)) return;

    setObservableNodes(observableNodes.add(id));

    observer.instanse.observe(node);
  }

  function fetchMoreContent(chunk) {
    if (!fetchMore) return;

    setLoading(true);

    fetchMore({
      variables: { limit: chunk, offset: list.length },
      updateQuery: (prev, { fetchMoreResult }) => {
        setLoading(false);

        if (!fetchMoreResult) return;

        return {
          campaigns: [...prev.campaigns, ...fetchMoreResult.campaigns]
        };
      }
    });
  }
}
